export const ResourceStates = {
  loaded: "LOADED",
  unloaded: "UNLOADED",
  loading: "LOADING",
  error: "ERROR",
};
